import { BarChart3 } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const ixinaDashboardManifest: ModuleDefinition = {
  id: 'ixina-dashboard',
  name: 'Smart Dashboard',
  icon: <BarChart3 size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/dashboard',
  status: 'active',
  navItems: [
    { label: 'Cockpit', path: '/dashboard/cockpit', icon: '🏪' },
    { label: 'Cijfers', path: '/dashboard/overzicht', icon: '📊' },
    { label: 'Verkopers', path: '/dashboard/verkopers', icon: '👥' },
    { label: 'Plaatsers', path: '/dashboard/plaatsers', icon: '🔧' },
    { label: 'Geografie', path: '/dashboard/geografie', icon: '🗺️' },
    { label: 'Orderboek', path: '/dashboard/orderboek', icon: '📦' },
    { label: 'Fronten', path: '/dashboard/fronten', icon: '🎨' },
    { label: 'Bonussen', path: '/dashboard/bonussen', icon: '💰' },
    { label: 'Import', path: '/dashboard/import', icon: '📥' },
    { label: 'Portfolio', path: '/dashboard/portfolio', icon: '📋' },
    { label: 'Doelen', path: '/dashboard/doelen', icon: '🎯' },
    { label: 'Rapportages', path: '/dashboard/rapportages', icon: '📧' },
    { label: 'Winkels', path: '/dashboard/entities', icon: '🏪' },
    { label: 'Monitor', path: '/dashboard/monitor', icon: '📡' },
    { label: 'Benchmark', path: '/dashboard/benchmark', icon: '🏆' },
    { label: 'Health', path: '/dashboard/health', icon: '💚' },
    { label: 'Builder', path: '/dashboard/builder', icon: '🧩' },
    { label: 'Admin', path: '/dashboard/superadmin', icon: '🛡️' },
    { label: 'Config', path: '/dashboard/system-config', icon: '⚙️' },
    { label: 'Login als', path: '/dashboard/impersonate', icon: '🎭' },
  ],
  component: () => import('./index.js'),
};

export default ixinaDashboardManifest;
